import posthog from 'posthog-js'
import { computed, ref } from 'vue'

export const distinctId = ref('')
export const sessionId = ref('')

export function buildUrl(url: string) {
	return computed(() => {
		if (!sessionId.value || !distinctId.value) {
			return url
		}
		return `${url}#session_id=${sessionId.value}&distinct_id=${distinctId.value}`
	})
}

const hashParams = new URLSearchParams(window.location.hash.substring(1))
export const distinct_id = hashParams.get('distinct_id')
const session_id = hashParams.get('session_id')
posthog.init('phc_jK2vCDMVsX8YZaBH69w1ZbBaPhH2ED2LqyTbXsGSAPc', {
	api_host: 'https://eu.i.posthog.com',
	capture_pageview: false,
	bootstrap: {
		sessionID: session_id ?? undefined,
		distinctID: distinct_id ?? undefined,
	},
	persistence: 'localStorage',
	disable_session_recording: import.meta.env.MODE === 'production',
	loaded: (posthog) => {
		distinctId.value = posthog.get_distinct_id()
		sessionId.value = posthog.get_session_id()

		if (import.meta.env.MODE === 'development') {
			posthog.opt_out_capturing() // opts a user out of event capture
		}
	},
})

export function usePostHog() {
	return {
		posthog,
		buildUrl,
	}
}
